import { NgModule } from '@angular/core';

import { TagModule } from './tags';
import { CardModule } from './card';
import { HeroModule } from './hero';
import { MetaModule } from './meta';
import { BrandModule } from './brand';
import { ToastModule } from './toast';
import { BadgeModule } from './badge';
import { ErrorModule } from './errors';
import { InputModule } from './inputs';
import { SearchModule } from './search';
import { AvatarModule } from './avatar';
import { CookieModule } from './cookie';
import { SwitchModule } from './switch';
import { ButtonModule } from './buttons';
import { NavBarModule } from './nav-bar';
import { TooltipModule } from './tooltip';
import { DropdownModule } from './dropdown';
import { TimelineModule } from './timeline';
import { PasswordModule } from './password';
import { JumbotronModule } from './jumbotron';
import { CheckRadioModule } from './check-radio';

@NgModule({
    exports: [
        TagModule,
        CardModule,
        HeroModule,
        BadgeModule,
        MetaModule,
        BrandModule,
        InputModule,
        ErrorModule,
        ToastModule,
        ButtonModule,
        AvatarModule,
        CookieModule,
        NavBarModule,
        SearchModule,
        SwitchModule,
        TooltipModule,
        DropdownModule,
        PasswordModule,
        TimelineModule,
        JumbotronModule,
        CheckRadioModule,
    ],
})

export class ElementModule {}
